import Image from "next/image"
import { getThemeClass } from "~/styles/styles"
import Section from "../common/section"
import { StaticImport } from "next/dist/shared/lib/get-img-props"

export type SimpleTextProps = {
  id?: string // for section href

  title?: string | JSX.Element
  titlesm?: boolean
  titleColour?: string
  body?: string | string[] | JSX.Element
  bodyWidth?: string // fixed content width
  afterAction?: JSX.Element
  afterActionFull?: boolean

  theme?: string
  bgClass?: string
  extraBgClass?: string

  image?: string | StaticImport
  imgLeft?: boolean
  imgPosition?: string
  hideImageOnMobile?: boolean

  padding?: "sm" | "md"
  xPadding?: string
  lineGap?: string
  multiLine?: boolean
  flexHeight?: boolean // flexible section height
  sectionHeightClass?: string
  customBorder?: string
  divClass?: string

  customPadding?: boolean // padding to connect with mobile testimonial section
}

const SimpleTextSection = (props: SimpleTextProps) => {
  const body = Array.isArray(props.body)
    ? props.body.map((line, i) => (
        <p key={i} className="mt-4 lg:mt-6 xl:mt-8">
          {line}
        </p>
      ))
    : props.body

  const titleClass = props.titlesm
    ? `font-bold text-desk-resp-3xl ${props.theme === "light" ? "text-purpleblue" : props.titleColour}`
    : `font-bold text-desk-resp-4_5xl ${props.theme === "light" ? "text-purpleblue" : props.titleColour}`

  const customPadding = `${props.customPadding ? "pb-44 sm:pb-44" : ""}`
  const padding =
    props.padding === "sm" ? `py-12 sm:py-16 lg:py-20 ${customPadding}` : props.padding === "md" ? `py-12 sm:py-24 md:py-36 ${customPadding}` : `py-28 sm:py-32 md:py-44 xl:py-48 ${customPadding}`
  return (
    <Section
      flexHeight={props.flexHeight}
      className={`relative flex overflow-hidden ${props.sectionHeightClass ?? ""} ${props.bgClass ?? ""} ${props.theme ? getThemeClass(props.theme, props.customBorder ?? undefined) : props.bgClass ? "" : getThemeClass("light")}`}
      id={props.id}
    >
      <div className={`relative mx-auto flex w-full xl:max-w-7xl ${props.extraBgClass ?? ""}`}>
        <div className={`container relative mx-auto flex flex-col ${props.divClass ?? "items-center justify-center text-center"}  leading-8 ${props.xPadding ?? "px-8 xs:px-2"} ${padding}`}>
          {typeof props.title === "string" ? <h2 className={`mb-4 lg:mb-6 xl:mb-8 ${titleClass}`}>{props.title}</h2> : props.title && <div className={`mb-2 ${titleClass}`}>{props.title}</div>}

          {props.body && (
            <div
              className={`text-resp-lg leading-normal z-10 flex flex-col ${props.lineGap ?? "gap-4 md:gap-6 lg:gap-8"} ${props.bodyWidth ?? "w-[19rem] xs:w-[25rem] sm:w-[30rem] md:w-[36rem] lg:w-[46rem]"} ${props.multiLine ? "text-desk-resp-xl" : "text-desk-resp-2xl"} `}
            >
              {body}
            </div>
          )}

          {props.afterAction && <div className={`mt-6 md:mt-8 ${props.image ? "mb-10 sm:mb-6 md:mb-8 lg:mb-0" : ""} ${props.afterActionFull ? "w-full" : ""}`}>{props.afterAction}</div>}
        </div>

        {props.image && (
          <Image
            src={props.image}
            alt="heart-image"
            width={1000}
            height={800}
            className={`absolute bottom-0 h-auto w-72 md:w-96 lg:w-[28rem] xl:w-[32rem] ${props.imgLeft ? (props.imgPosition ?? `-left-12 right-0 lg:-left-14 xl:-left-20`) : (props.imgPosition ?? `-right-14 md:-right-14 xl:-right-20`)} ${props.hideImageOnMobile ? "hidden xs:block" : ""}`}
          />
        )}
      </div>
    </Section>
  )
}

export default SimpleTextSection
